export class Layout {
    public static readonly SIDEBAR_COLLAPSED_WIDTH = 0;
    public static readonly SIDEBAR_EXPANDED_WIDTH = 275;
    public static readonly MOBILE_VIEWPORT_WIDTH = 768;
    public static readonly MOBILE_VIEWPORT_HEIGHT = 550;
}

export class AlertSeverity {
    public static readonly Default = "";
    public static readonly Info = "Info";
    public static readonly Success = "Success";
    public static readonly Warning = "Warning";
    public static readonly Error = "Error";
}

export class UserPermissions {
    public static readonly ONBOARD_DEALERSHIPS = "DealershipOnboarding";
    public static readonly MANAGE_DEALERSHIP_ACCOUNTS =
        "ManageDcpDealerAccounts";
    public static readonly MANAGE_CUSTOMER_ACCOUNTS = "ManageDcpCustomers";
    public static readonly DOWNLOAD_DOCUMENTS = "DownloadDcpDocuments";
    public static readonly CUSTOMISE_APPEARANCE = "CustomiseDcpAppearance";
    public static readonly CUSTOMISE_SETTINGS = "CustomiseDcpSettings";
}

export class UserRoles {
    public static readonly GOLD_ADMIN = "Gold Admin";
    public static readonly DCP_DEALERSHIP_ADMIN = "DCP Dealer Admin";
    public static readonly DCP_DEALERSHIP_USER = "DCP Dealer User";
    public static readonly DCP_CUSTOMER_USER = "DCP Customer User";
}

export class DCPPathNames {
    public static readonly DASHBOARD_PATH = "/dashboard";
    public static readonly DCP_CUSTOMIZATION_PATH = "/customize/portal";
    public static readonly DEALERSHIP_DASHBOARD_PATH = "/dealership/dashboard";
    public static readonly DEALERSHIP_CONFIGURATION_PATH =
        "/dealer/configuration";
    public static readonly DEALERSHIP_USERS_PATH = "/dealership/users";
    public static readonly CUSTOMER_ACCOUNTS_PATH = "/customer/accounts";
    public static readonly CUSTOMER_ACCOUNTS_REGISTERED_PATH =
        "/customer/accounts/registered";
    public static readonly CUSTOMER_ACCOUNTS_INVITE_PATH =
        "/customer/accounts/invite";
    public static readonly CUSTOMER_ACTIVITY_PATH = "/customer/activity";
    public static readonly CUSTOMER_STATEMENTS_PATH = "/customer/statements";
    public static readonly PROFILE_PATH = "/profile";
    public static readonly DEALERSHIP_SETTINGS_CONFIGURATION_PATH =
        "/dealership/configuration";
    public static readonly DEALERSHIP_AUDIT_VIEW = "/dealership/audit";
    public static readonly CUSTOMER_REQUESTS_PATH =
        "/customer/accounts/customer-signup-requests";
    public static readonly DEALERSHIP_LANDING_PAGE_CONFIGURATION_PATH =
        "/dealership/landingpage/configuration";
    public static readonly DEALERSHIP_LANDING_PAGE_PREVIEW_PATH =
        "/dealership/landingpage/preview";
    public static readonly CUSTOMER_SELF_SIGNUP_PATH =
        "/customer/signup/:dealershipUrl";
    public static readonly CUSTOMER_PRE_LOGIN_LANDING_PAGE_PATH =
        "/:dealershipUrl";
}

export const validEmailRegex: RegExp =
    /^$|^(?=.{1,64}@)(?=.{1,320}$)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const validUrlRegex: RegExp =
    /^$|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/;

export class PanelObjects {
    public static readonly HEADER_COLOR = "HeaderColor";
    public static readonly BUTTON_COLOR = "ButtonColor";
    public static readonly IMAGE = "Image";
    public static readonly IMAGE_URL = "ImageLinkedPromotionalURL";
}

export class PanelDimensions {
    public static readonly BANNER = "1911 x 411";
    public static readonly PANEL = "620 x 446";
}

export class DCPDefaultTheme {
    public static readonly MAIN_COLOR = "#393939";
    public static readonly TEXT_COLOR = "#ffffff";
    public static readonly BUTTON_COLOR = "#EECB84";
    public static readonly PRIMARY_COLOR = "#477177";
    public static readonly CONTENT_TEXT_COLOR = "#ffffff";
}

export class SocialMediaPlatforms {
    public static readonly FACEBOOK = "https://www.facebook.com";
    public static readonly INSTAGRAM = "https://www.instagram.com";
    public static readonly LINKEDIN = "https://www.linkedin.com";
    public static readonly TWITTER = "https://x.com";
    public static readonly YOUTUBE = "https://www.youtube.com";
    public static readonly TIKTOK = "https://www.tiktok.com";
    public static readonly WEBSITE = "https://www.ibcos.co.uk";
}

export const socialMediaUrlPatterns = {
    facebookUrl:
        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?facebook(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/,
    instagramUrl:
        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?instagram(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/,
    linkedInUrl:
        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?linkedin(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/,
    twitterXUrl:
        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?twitter|x(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/,
    youTubeUrl:
        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?youtube(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/,
    tikTokUrl:
        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?tiktok(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/,
    websiteUrl: validUrlRegex,
};

export const durationOptions = [
    { label: "6 Months", value: "6M" },
    { label: "1 Year", value: "1Y" },
    { label: "2 Years", value: "2Y" },
    { label: "5 Years", value: "5Y" },
    { label: "7 Years", value: "7Y" },
];

export class UserStatus {
    public static readonly PENDING = "Pending";
    public static readonly REVOKED = "Revoked";
    public static readonly ACTIVE = "Active";
    public static readonly DISABLED = "Disabled";
    public static readonly INACTIVE = "Inactive";
    public static readonly LOCKED = "Locked";
    public static readonly EXPIRED = "Expired";
}

export enum DealershipLandingPageEditorDataState {
    DRAFT = "Draft",
    LIVE = "Live",
}

export const MIN_API_VERSION: string = "7.34.4";

export enum GoldStopStatus {
    NO = "No",
    WARNING = "Warning",
    TOTAL_STOP = "Total Stop",
}
